export default "__VITE_ASSET__BqfI5sS___"